import { RoutesRoot } from "./Routes";
import { Header, Footer, HeaderLogin } from "./Includes";


function App() {

    return (
        <>
            {/* <HeaderLogin /> */}
            <Header />

            <main className="container-fluid" style={{ position: 'relative', top: '80px' }}>
                <RoutesRoot />
            </main>

            <Footer />
        </>
    );
}

export default App;
